export default "__VITE_ASSET__13ccd9ba__"